var Locale = /* @__PURE__ */ ((Locale2) => {
  Locale2["deDE"] = "de-DE";
  Locale2["esES"] = "es-ES";
  Locale2["enUS"] = "en-US";
  Locale2["enGB"] = "en-GB";
  Locale2["fiFI"] = "fi-FI";
  Locale2["nlNL"] = "nl-NL";
  Locale2["itIT"] = "it-IT";
  Locale2["svSE"] = "sv-SE";
  Locale2["nbNO"] = "nb-NO";
  Locale2["ptPT"] = "pt-PT";
  Locale2["daDK"] = "da-DK";
  Locale2["frCA"] = "fr-CA";
  Locale2["esUS"] = "es-US";
  Locale2["enCA"] = "en-CA";
  Locale2["nlBE"] = "nl-BE";
  Locale2["enIE"] = "en-IE";
  Locale2["frBE"] = "fr-BE";
  Locale2["frFR"] = "fr-FR";
  Locale2["frCH"] = "fr-CH";
  Locale2["deAT"] = "de-AT";
  Locale2["deCH"] = "de-CH";
  Locale2["itCH"] = "it-CH";
  Locale2["enAU"] = "en-AU";
  Locale2["enNZ"] = "en-NZ";
  Locale2["enSG"] = "en-SG";
  Locale2["enIN"] = "en-IN";
  return Locale2;
})(Locale || {});

export { Locale };
//# sourceMappingURL=src-types-locales.js.map
